<div class="fixed bottom-4 right-4 z-50 flex flex-col gap-3 w-80">

  @for (notification of notificationService.notifications(); track notification.id) {

    <div
      class="flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg text-sm text-white
             animate-slide-in"
      [ngClass]="{
        'bg-green-500': notification.type === 'success',
        'bg-red-500': notification.type === 'error',
        'bg-secondary/100': notification.type === 'info',
        'bg-yellow-500': notification.type === 'warning'
      }"
    >

      <span class="flex-1">
        {{ notification.message }}
      </span>

      <button
        class="text-white/80 hover:text-white"
        (click)="notificationService.remove(notification.id)"
      >
        <lucide-icon [name]="X" [size]="20"></lucide-icon>
      </button>

    </div>

  }
</div>
